import React, { Component } from 'react'
import Routes from '../src/routes';

export default class App extends Component {
  render() {
    return (
      <div>
        <Routes/>
      </div>
    )
  }
}
